(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["myko-preferences-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    let explicitTheme = null;
    try { explicitTheme = localStorage.getItem('myko-color-mode'); } catch (_) {}
    function sync() {
      const dark = root.dataset.mykoTheme === 'dark';
      const simple = root.dataset.mykoReading === 'simple';
      document.querySelectorAll('[data-myko-theme-toggle]').forEach(button => {
        const label = dark ? button.dataset.labelLight : button.dataset.labelDark;
        button.setAttribute('aria-pressed', String(dark));
        button.setAttribute('aria-label', label);
        button.title = label;
      });
      document.querySelectorAll('[data-myko-reading-toggle]').forEach(button => {
        const label = simple ? button.dataset.labelNormal : button.dataset.labelSimple;
        button.setAttribute('aria-pressed', String(simple));
        button.setAttribute('aria-label', label);
        button.title = label;
      });
    }
    function announce(mode) {
      const status = document.getElementById('MykoPreferenceStatus');
      if (status) status.textContent = status.dataset[mode];
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-myko-theme-toggle], [data-myko-reading-toggle]');
      if (!button) return;
      if (button.hasAttribute('data-myko-theme-toggle')) {
        explicitTheme = root.dataset.mykoTheme === 'dark' ? 'light' : 'dark';
        root.dataset.mykoTheme = explicitTheme;
        try { localStorage.setItem('myko-color-mode', explicitTheme); } catch (_) {}
        announce(explicitTheme);
      } else {
        const reading = root.dataset.mykoReading === 'simple' ? 'normal' : 'simple';
        root.dataset.mykoReading = reading;
        try { localStorage.setItem('myko-reading-mode', reading); } catch (_) {}
        announce(reading);
      }
      sync();
    });
    media.addEventListener('change', event => {
      if (explicitTheme === 'dark' || explicitTheme === 'light') return;
      root.dataset.mykoTheme = event.matches ? 'dark' : 'light';
      sync();
    });
    window.addEventListener('storage', event => {
      if (event.key === 'myko-color-mode' || event.key === null) {
        explicitTheme = event.newValue;
        root.dataset.mykoTheme = explicitTheme === 'dark' || explicitTheme === 'light' ? explicitTheme : (media.matches ? 'dark' : 'light');
      }
      if ((event.key === 'myko-reading-mode' || event.key === null) && root.lang.startsWith('de')) root.dataset.mykoReading = event.newValue === 'simple' ? 'simple' : 'normal';
      sync();
    });
    document.addEventListener('shopify:section:load', sync);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
    else sync();
  })();
  } catch(e) { console.error(e); }
})();

})();
